import type { FHRequest } from '../types';

/**
 * Check if the current user can perform work actions on a request.
 * Work actions include: sending messages, making calls, sending emails.
 *
 * Access is granted if:
 * 1. User is an assistant (isAssistant = true)
 * 2. User is the one who claimed the request (compare UUIDs for consistency)
 */
export const canWorkOnRequest = (
  request: FHRequest,
  userUuid: string | undefined,
  isAssistant: boolean
): boolean => {
  if (!isAssistant) return false;

  // Must be the claimer to work on a request - compare UUIDs for consistency
  return request.assistant_uuid === userUuid;
};
